import { QRFC } from "./QRFC";

export class QCleanupPublishRFC extends QRFC {
  constructor() {
    super();
  }

  InitCleanupRFC() {
    this.InitRemoteCall(null, "POST", true, false);
  }

  GetCallName() {
    return "qcleanuppublish";
  }

  SetParams(org, user, fileList) {
    var data = [];
    for (var fileIdx in fileList) {
      if (fileList[fileIdx]) data.push(fileList[fileIdx]);
    }

    this.AddParameter("org", org);
    this.AddParameter("user", user);
    this.AddParameter("files", JSON.stringify(data));
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    // We don't care what happens on the server side
  }
}
